<template>
  <div class="c-shutdown g-container">
    <Spin v-if="show" size="large" fix />
    <div class="module-content" ref="container">
      <moduler name="dmpadd" title="创建一键关停">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">类型</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="taskType" type="button" @on-change="taskTypeChange">
              <Radio :label="0">一键素材关停</Radio>
              <Radio :label="1">一键计划关停</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">操作类型</span>
          </Col>
          <Col span="12" v-show="taskType === 1">
            <RadioGroup v-model="opType" type="button">
              <Radio :label="0">暂停计划</Radio>
              <Radio :label="-1" :disabled="taskType === 1">删除计划</Radio>
            </RadioGroup>
            <span v-if="taskType === 1">
              <span style="color: #ff4400; margin-top: 10px; display: block">
                特别注意：为了防止自动化任务的启用规则自动重启关闭的任务，请去暂停启用规则的自动化任务或者去系统-任务管理关闭整个任务
              </span>
            </span>
          </Col>

          <Col span="12" v-show="taskType === 0">
            <RadioGroup v-model="opType" type="button" @on-change="opTaskTypeChange">
              <Radio :label="2">暂停素材</Radio>
              <Radio :label="3">删除素材</Radio>
              <Radio :label="0">暂停计划</Radio>
              <Radio :label="-1">删除计划</Radio>
            </RadioGroup>
            <span>
              <span style="color: #ff4400; margin-top: 10px; display: block">
                注意：“暂停素材”只对巨量引擎的计划有效，其余媒体不支持该功能。
              </span>
            </span>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="taskType === 0">
          <Col span="3" class="col-item">
            <span class="item-field">素材</span>
          </Col>
          <Col span="12">
            <mater-modal v-model="detailIds" :type-data="typeData" :label-data="labelData" :operator-data="operatorData" :max="300" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="taskType === 1">
          <Col span="3" class="col-item">
            <span class="item-field">平台</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="platform" type="button">
              <Radio :label="0">全部</Radio>
              <Radio :label="2">iOS</Radio>
              <Radio :label="1">安卓</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="taskType === 1">
          <Col span="3" class="col-item">
            <span class="item-field">游戏</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="gameType" type="button">
              <Radio :label="1">全部</Radio>
              <Radio :label="2">选择游戏</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="gameType === 2">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="12">
            <game-modal v-model="gameIds" :game-data="gameData" :width="280" size="large" placeholder="选择游戏" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">账号</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="accountType" type="button">
              <Radio :label="1">全部</Radio>
              <Radio :label="2">选择账号</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="accountType === 1">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">媒体</span>
          </Col>
          <Col span="12">
            <Mixcheck v-model="mediaIds">
              <check-item :label="10">巨量引擎</check-item>
              <check-item :disabled="opType === 2" :label="16">腾讯</check-item>
              <check-item :disabled="opType === 2" :label="32">磁力引擎</check-item>
              <check-item :disabled="opType === 2" :label="45">百度信息流</check-item>
            </Mixcheck>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="accountType === 2">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="12">
            <account-modal
              v-model="accountIds"
              :media-data="mediaData"
              :operator-data="operatorData"
              :width="280"
              :max="500"
              placeholder="选择计划账号"
            />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">操作状态</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="adStatus" type="button">
              <Radio :label="1">启用中</Radio>
              <Radio :label="0" :disabled="taskType === 1">已暂停</Radio>
              <Radio :label="2" :disabled="taskType === 1">全部</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划新建时间</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="adTimeRange" type="button">
              <Radio :label="1">1个月以内</Radio>
              <Radio :label="2">3个月以内</Radio>
              <Radio :label="3">6个月以内</Radio>
            </RadioGroup>
          </Col>
        </Row>
      </moduler>
    </div>
    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []" />
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(0)">
            <span v-if="!loading">更新</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit(1)">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { isArray, timeout } from '@/common/js/utils'
import validMixin from '../mixins/valid-mixin'

import Moduler from '@/components/moduler.vue'
import AccountModal from '@/components/accountmodal'
import MaterModal from '@/components/matermodal'
import ErrorPop from '@/components/error-pop.vue'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import GameModal from '@/components/gamemodal'

import { getSysTag, getSysMember, getGameGroupTree } from '@/api/common.model'
import { addImagePlan } from '@/api/manage.model'
export default {
  name: 'stAdd',
  mixins: [validMixin],
  components: { Moduler, ErrorPop, Mixcheck, CheckItem, AccountModal, MaterModal, GameModal },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    }
  },
  data() {
    return {
      loading: null,
      show: null,
      formErr: null,
      errRes: [],

      operatorData: [],
      typeData: [],
      labelData: [],
      mediaData: [
        { id: 10, name: '巨量引擎' },
        { id: 16, name: '腾讯' },
        { id: 32, name: '磁力引擎' },
        { id: 45, name: '百度信息流' }
      ],

      detailIds: [],
      accountType: 1,
      accountIds: [],
      mediaIds: [10],
      adTimeRange: 3,
      opType: 0,
      taskType: 0,
      platform: 0,
      gameType: 1,
      gameIds: [],
      gameData: [],
      adStatus: 1
    }
  },
  methods: {
    opTaskTypeChange(type) {
      if (type === 2) {
        this.mediaIds = [10]
      }
    },
    valid() {
      const rules = [
        {
          name: 'detailIds',
          require: true,
          relyon: 'taskType',
          relyvalue: 0,
          min: 1,
          max: 300,
          desc: '素材'
        },
        {
          name: 'accountIds',
          require: true,
          relyon: 'accountType',
          relyvalue: 2,
          desc: '计划账号'
        },
        {
          name: 'gameIds',
          require: true,
          relyon: 'gameType',
          relyvalue: 2,
          desc: '游戏'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(bool) {
      this.errRes = [...this.valid()]

      if (this.errRes.length) {
        this.formErr = true
        return
      }

      const params = {
        detailIds: this.detailIds,
        accountIds: this.accountIds,
        mediaIds: this.mediaIds,
        adTimeRange: this.adTimeRange,
        opType: this.opType,
        adStatus: this.adStatus,
        taskType: this.taskType,
        platform: this.platform,
        gameIds: this.gameIds
      }

      if (this.accountType === 2) delete params.mediaIds
      else delete params.accountIds

      if (this.taskType === 0) {
        delete params.platform
        delete params.gameIds
      } else delete params.detailIds

      this.loading = true
      addImagePlan(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    },
    jump() {
      this.$router.push({ name: 'shutdownlist' })
    },
    taskTypeChange(val) {
      this.detailIds = []
      this.platform = 0
      this.gameType = 1
      this.gameIds = []
      this.adStatus = 1
      this.opType = 0
    },
    preloadData() {
      Promise.all([getSysMember(), getSysTag(), getGameGroupTree()]).then((data) => {
        const [operatorData, labels, groupData] = data

        this.typeData = [
          { id: 1, name: '图片' },
          { id: 2, name: '视频' }
        ]
        if (isArray(labels)) {
          this.labelData = labels.map((ret) => {
            return { id: ret.labelId, name: ret.content }
          })
        }
        isArray(operatorData) && (this.operatorData = operatorData)
        if (isArray(groupData)) {
          this.gameData = groupData.map((ret) => {
            const obj = { id: ret.gameGroupId, name: ret.gameGroupName }
            if (isArray(ret.children)) {
              Object.assign(obj, {
                children: ret.children
                  .filter((met) => met.gameName)
                  .map((met) => {
                    return { id: met.gameId, name: met.gameName }
                  })
              })
            }
            return obj
          })
        }
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-shutdown {
  height: 100%;

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;

    height: calc(100% - 58px);
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

/* 必填项 */
::v-deep .row-item-must {
  position: relative;
  z-index: 5;

  &:after {
    content: ' ';
    display: inline-block;
    width: 4px;
    height: 4px;
    position: absolute;
    top: 6px;
    right: 0;
    background-color: #f45858;
    border-radius: 3px;
  }

  /* 单选框覆盖 */
}

::v-deep .ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}
</style>
